"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/util/ConstantDiv.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ConstantDiv =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ConstantDiv, _Component);

  function ConstantDiv() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ConstantDiv.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate() {
    // disable react on this div
    return false;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        registerChild = _this$props.registerChild,
        style = _this$props.style,
        onClick = _this$props.onClick;
    return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
      _react.default.createElement("div", {
        className: className,
        ref: registerChild,
        style: style,
        onClick: onClick,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        },
        __self: this
      }, this.props.children)
    );
  };

  return ConstantDiv;
}(_react.Component);

exports.default = ConstantDiv;
ConstantDiv.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.string,
  registerChild: _propTypes.default.func,
  onClick: _propTypes.default.func,
  style: _propTypes.default.objectOf(_propTypes.default.string),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
} : {};
ConstantDiv.defaultProps = {
  className: '',
  registerChild: '',
  onClick: null,
  style: {},
  children: []
};